import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Quotation } from '../../../clients/interface/data.interface';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DetailSimulationModalComponent } from '../modals/detail-simulation-modal/detail-simulation-modal.component';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ValidClient } from '../../../factoring/interface/data.interface';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { CompaniesFactoringService } from '../../../factoring/services/companies-factoring.service';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';

@Component({
  selector: 'app-table-simulations',
  templateUrl: './table-simulations.component.html',
  styleUrl: './table-simulations.component.scss'
})
export class TableSimulationsComponent {
  public dataSource: MatTableDataSource<Quotation> = new MatTableDataSource([]);
  @ViewChild(MatPaginator, { static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true}) sort: MatSort;
  @Output() sorting = new EventEmitter<any>;
  @Output() pagination = new EventEmitter<any>;
  @Output() reload = new EventEmitter<any>;
  @Input() cotizaciones: Quotation[];
  @Input() page: number;
  @Input() pageSize: number;
  @Input() totalRows: number;
  @Output() quoteSelected = new EventEmitter<Quotation>();
  public loading = true;
  private userId: number;
  public displayCols = [
    'code',
    'statusName',
    'client',
    'amount',
    'finalPrice',
    'totalDiscount',
    'averageRate',
    'ir',
    'executiveName',
    'aproveUser',
    'createdAt',
  ];

  constructor(private auth: AuthService, private dialog: MatDialog, private cdr: ChangeDetectorRef, private router: Router, private configuracionRut: ConfigRutService, private companyService: CompaniesFactoringService) {}

  ngOnInit(): void {
    this.userId = parseInt(this.auth.getRutUser());
  }

  ngAfterViewInit(): void {
    this.paginator = this.paginator;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cotizaciones'] && changes['cotizaciones'].currentValue) {
      this.setDataSource(); 
    }
  }

  public redirectDashbardClient(rut: string) {
    Swal.fire({
      title: 'Por favor espera...',
      text: 'Te estamos redigiendo al Cliente.',
      allowOutsideClick: false, 
      didOpen: () => {
        Swal.showLoading(); 
      },
    });
  
    var companyId = rut.substring(0, rut.length - 2);
    var companyRut = this.validarRut(parseInt(companyId));
    const requestBody: ValidClient = {
      companyRut: companyRut,
      typeCompany: 'isClient',
      userId: this.userId,
    };
  
    this.companyService.validClient(requestBody).subscribe({
      next: (e) => {
        Swal.close();
        window.open('dashboards/files-clients?client='+companyId, '_blank');
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      }
    });
  }

  public validarRut(rut): any {
    console.log(rut);
    var formattedRut = this.configuracionRut.formatRutWithDv(rut);
    return formattedRut;
  }
  
  public changeSorting(sortState: Sort): void {
    if(sortState.direction === '') {
      this.sorting.emit(null);
      return;
    }
    const sorting =  {
      orderBy: sortState.active,
      orderDirection: sortState.direction.toLowerCase()
    };
    this.sorting.emit(sorting);
  }

  public openModalDetaiSimulation(simulation: Quotation) {
    this.quoteSelected.emit(simulation); 
    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = false;
    // dialogConfig.width = '86vw';
    // //dialogConfig.height = '76vh';
    // dialogConfig.maxWidth = '90vw';
    // dialogConfig.maxHeight = '85vh';
    // dialogConfig.data = simulation;
    // var ref = this.dialog.open(DetailSimulationModalComponent, dialogConfig);
    // ref.afterClosed().subscribe(result => {
    //   this.reload.emit()
    // });
  }

  public changePagination(event: PageEvent) {
    const pagination = {
      page: event.pageIndex + 1,
      pageSize: event.pageSize
    };
    this.pagination.emit(pagination);
  }

  private setDataSource() {
    if (this.cotizaciones) {
      this.dataSource.data = this.cotizaciones;
      this.paginator.pageIndex = this.page - 1;
      this.paginator.pageSize = this.pageSize;
      this.paginator.length = this.totalRows;
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  public getDiscontMaxQuote(cuote: Quotation): string {
    if (!cuote.items || cuote.items.length === 0) {
      return '0%';
    }
    const maxItem = cuote.items.reduce((prev, current) => {
      return (prev.discountPercentage > current.discountPercentage) ? prev : current;
    });
    return `${(maxItem.discountPercentage*100).toFixed(2)}%`;
  }

  public getDiscontMaxQuoteNumber(cuote: Quotation): number {
    if (!cuote.items || cuote.items.length === 0) {
      return 0;
    }
    const maxItem = cuote.items.reduce((prev, current) => {
      return (prev.discountPercentage > current.discountPercentage) ? prev : current;
    });
    return parseFloat((maxItem.discountPercentage * 100).toFixed(2));
  }

  public getAprovatorDiscount(quotation: Quotation): string {
    for (const item of quotation.items) {
      const changeRequest = item.changeRequests.find(cr => cr.changeTypeId === -5);
      if (changeRequest && changeRequest.changeRequestLogs && changeRequest.changeRequestLogs.length > 0) {
        const lastLog = changeRequest.changeRequestLogs[changeRequest.changeRequestLogs.length - 1];
        if (lastLog.logMessage.includes("Solicitud de descuento aprobado por ")) {
          return lastLog.logMessage.split("Solicitud de descuento aprobado por ")[1];
        }
      }
    }
    return "-";
  }
  

  public getRejectDiscount(quotation: Quotation): string {  
    for (const item of quotation.items) {
      const changeRequest = item.changeRequests.find(cr => cr.changeTypeId === -5);
      if (changeRequest && changeRequest.changeRequestLogs && changeRequest.changeRequestLogs.length > 0) {
        const lastLog = changeRequest.changeRequestLogs[changeRequest.changeRequestLogs.length - 1];
        if (lastLog.logMessage.includes("Solicitud de descuento rechazado por ")) {
          return lastLog.logMessage.split("Solicitud de descuento rechazado por ")[1];
        }
      }
    }
    return "-";
  }
  

}